import { render } from "./NavBarINV.vue?vue&type=template&id=5124bde0&scoped=true"
import script from "./NavBarINV.vue?vue&type=script&lang=js"
export * from "./NavBarINV.vue?vue&type=script&lang=js"

import "./NavBarINV.vue?vue&type=style&index=0&id=5124bde0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5124bde0"]])

export default __exports__